import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { SiDataService } from '../../services/si-data.service';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';

@Injectable({
  providedIn: 'root'
})
export class SiTimezoneServiceService {

  preference_url: string = 'data/preferences';
  save_preference_url: string = 'data/savePreferences';
  userName: any;
  prefSubject = new BehaviorSubject<boolean>(false);

  constructor(private siDataService: SiDataService, private siAuthenticationService: SiAuthenticationService) { }


  getUserPreference(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {

      this.siDataService.getData(this.preference_url)
        .subscribe(
          (response) => {
            if (response.length > 0) {
              this.prefSubject.next(response[0].auto_refresh);
              response = this.getTransformedUserPreference(response);
            } else {
              this.prefSubject.next(true);
            }
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  savePreferences(timezone, refresh_mode): Observable<any> {
    this.prefSubject.next(refresh_mode);
    this.userName = this.siAuthenticationService.getUser().replace(/['"]+/g, '');
    const newObj = { userName: this.userName, timezone: timezone.name, auto_refresh: refresh_mode };
    return new Observable<Array<object>>((observer) => {
      this.siDataService.postData(this.save_preference_url, newObj)
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          }, (error) => {
            observer.error(error);
            observer.complete();
          });
    });
  }

  getTransformedUserPreference(preferenceList) {
    return preferenceList;
  }
}
